const FONT_FAMILIES = [
  {
    label: 'Arial',
    value: 'Arial',
    fontFamily: 'Arial'
  },
  {
    label: 'Verdana',
    value: 'Verdana',
    fontFamily: 'Verdana'
  },
  {
    label: 'Helvetica',
    value: 'Helvetica',
    fontFamily: 'Helvetica'
  },
  {
    label: 'Tahoma',
    value: 'Tahoma',
    fontFamily: 'Tahoma'
  },
  {
    label: 'Trebuchet MS',
    value: 'Trebuchet MS',
    fontFamily: 'Trebuchet MS'
  },
  {
    label: 'Times New Roman',
    value: 'Times New Roman',
    fontFamily: 'Times New Roman'
  },
  {
    label: 'Georgia',
    value: 'Georgia',
    fontFamily: 'Georgia'
  },
  {
    label: 'Garamond',
    value: 'Garamond',
    fontFamily: 'Garamond'
  },
  {
    label: 'Courier New',
    value: 'Courier New',
    fontFamily: 'Courier New'
  },
  {
    label: 'Brush Script MT',
    value: 'Brush Script MT',
    fontFamily: 'Brush Script MT'
  },
  {
    label: 'Impact',
    value: 'Impact',
    fontFamily: 'Impact'
  },
  {
    label: 'Comic Sans MS',
    value: 'Comic Sans MS',
    fontFamily: 'Comic Sans MS'
  },
  {
    label: 'Lucida Sans Unicode',
    value: 'Lucida Sans Unicode',
    fontFamily: 'Lucida Sans Unicode'
  },
  {
    label: 'Palatino Linotype',
    value: 'Palatino Linotype',
    fontFamily: 'Palatino Linotype'
  },
  {
    label: 'Segoe UI',
    value: 'Segoe UI',
    fontFamily: 'Segoe UI'
  }
];

const CUSTOM_FONT_FAMILIES = [
  {
    label: 'Varsity',
    value: 'ClassicVarsity',
    fontFamily: 'ClassicVarsity'
  },
  {
    label: 'Jersey',
    value: 'ClassicJersey',
    fontFamily: 'ClassicJersey'
  }
];

export { FONT_FAMILIES, CUSTOM_FONT_FAMILIES };
